export function percentFormatter(params) {
	let value = Number(params.value);
	return isNaN(value) ? '' : Number(value).toFixed(2).replace('.', ',') + ' %';
}

export function floatFormatter(params) {
	let value = Number(params.value);
	return isNaN(value) ? '' : numbro(value).format({thousandSeparated: true, mantissa: 2});
}

export function intFormatter(params) {
	let value = Number(params.value);
	return isNaN(value) ? '' : numbro(value).format({thousandSeparated: true, mantissa: 0});
}

export function currencyFormatter(params) {
	let value = Number(params.value);
	return isNaN(value) ? '' : numbro(value).formatCurrency({
		thousandSeparated: true,
		mantissa: 0,
		spaceSeparated: true
	});
}
